import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../../assets/css/teacherTimeTable.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from 'react-router-dom';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const TeacherTimeTableCard = (props) => {
    const { catchResponse } = useCatchResponse();
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [periodsList, setPeriodsList] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [timetableData, setTimetableData] = useState([]);
    const navigate = useNavigate();

    const GetTimeTableData = async (teacherId) => {
        try {
            let data = {
                TeacherId: teacherId
            }
            const response = await api.post(APIConstant.path.GetTimeTableByTeacher, data);
            if (response.success && response.data.length > 0) {
                let periodData = response.data[0]?.Periods?.map((x, idx) => {
                    return { Time: x?.Time, isBreak: x?.SubjectId === 'Free' ? true : false }
                });
                setPeriodsList(periodData);
                let timeTableData = response.data.map(row => {
                    const formattedRow = { Day: row?.Day, id: row?.id };
                    row?.Periods.forEach((period, index) => {
                        formattedRow[`Period${index + 1}`] = period?.SubjectId === 'Free' ? period?.SubjectId : period?.SubjectName;
                        formattedRow[`Class${index + 1}`] = period?.ClassId === 'Free' ? period?.ClassId : period?.ClassName;
                    });
                    return formattedRow;
                });
                let timeTableEditData = response.data.map(row => {
                    const formattedRow = { Day: row?.Day, id: row?.id };
                    row?.Periods.forEach((period, index) => {
                        formattedRow[`Period${index + 1}`] = period?.SubjectId;
                        formattedRow[`Class${index + 1}`] = period?.ClassId;
                        formattedRow[`isFree${index + 1}`] = period?.ClassId === 'Free' ? true : false;
                    });
                    return formattedRow;
                });
                const sortedData = timeTableData.sort((a, b) => {
                    return days.indexOf(a?.Day) - days.indexOf(b?.Day);
                });
                const EditsortedData = timeTableEditData.sort((a, b) => {
                    return days.indexOf(a?.Day) - days.indexOf(b?.Day);
                });

                setTimetableData(sortedData);
            } else {
                setPeriodsList([]);
                setTimetableData([]);
            }
        } catch (error) {
            console.error("Error fetching timetable:", error);
            catchResponse(error);
        }
    };

    const toggleExpand = (value) => {
        if (value) {
            GetTimeTableData(props?.TeacherId);
        }
        setIsExpanded(value);
    };

    const printTimeTable = () => {
        try {
            Loader.show();
            const doc = new jsPDF();
            doc.setFontSize(16);
            doc.text(`Time Table for Teacher: ${props?.TeacherName}`, 10, 10);

            const columns = [
                { header: "Days/Periods", dataKey: "Day" },
                ...periodsList.map((period, index) => ({
                    header: period?.Time,
                    dataKey: `Period${index + 1}`,
                })),
            ];

            const rows = timetableData.map((row) => {
                const formattedRow = { Day: row.Day };
                periodsList.forEach((_, index) => {
                    formattedRow[`Period${index + 1}`] = row[`Period${index + 1}`] === 'Free' ? row[`Class${index + 1}`] : `${row[`Period${index + 1}`] ?? 'Free'} - ${row[`Class${index + 1}`] ?? 'Free'}`;
                });
                return formattedRow;
            });

            autoTable(doc, {
                columns: columns,
                body: rows,
                startY: 20,
                theme: "grid",
            });
            Loader.hide();
            doc.save(`Teacher_Time_Table_${props?.TeacherName || "Unknown"}.pdf`);
        } catch (error) {
            console.log('Error ');
            Loader.hide();
        }
    };

    return (
        <div className='time-table'>
            <div className="">
                <div className="p-d-flex p-ai-center p-jc-between">
                    <h2 className='p-mb-0'>{`Teacher : ${props?.TeacherName}`}</h2>
                    <div className="p-d-flex p-ai-center p-jc-between">
                        <Button icon="pi pi-pencil" className="e-sction-btn" onClick={() => navigate('/edit-teacher-time-table', { state: { classList: props?.ClassList, TeacherId: props?.TeacherId } })} />
                        <Button icon="pi pi-print" className="e-sction-btn p-mx-2" onClick={async () => {
                            if (periodsList.length !== 0) {
                                await GetTimeTableData(props?.TeacherId);
                            }
                            printTimeTable();
                        }} />
                        <Button
                            icon={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}
                            className="e-sction-btn"
                            onClick={() => toggleExpand(!isExpanded)}
                        />
                    </div>
                </div>
                {(isExpanded && periodsList.length !== 0) && (
                    <div className="p-mt-3">
                        <DataTable value={timetableData} responsiveLayout="scroll" className="custom-table" scrollHeight='min-content'>
                            <Column field="Day" header="Days/Periods" />
                            {periodsList?.map((period, index) => (
                                <Column
                                    key={index}
                                    field={`Period${index + 1}`}
                                    header={period?.Time}
                                    body={(rowData) =>
                                        rowData[`Class${index + 1}`] === 'Free' ? (
                                            rowData[`Period${index + 1}`]
                                        ) : (
                                            `${rowData[`Class${index + 1}`] ?? 'Free'} - ${rowData[`Period${index + 1}`] ?? 'Free'}`

                                        )
                                    }
                                />
                            ))}
                        </DataTable>
                    </div>
                )}

            </div>
        </div>

    );
};

export default TeacherTimeTableCard;
